import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Package, MessageSquare, Plus } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { isAuthenticated, logout } from '../utils/api';
import ProductManagement from '../components/admin/ProductManagement';
import ContactMessages from '../components/admin/ContactMessages';
import logo from '../assets/logo3.png';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('products');

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-[#FED09D]/20">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-[#B22222]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
            <div className="flex items-center gap-3 w-full sm:w-auto justify-center sm:justify-start">
              <img src={logo} alt="Griya Bakpia Logo" className="w-16 h-16 sm:w-20 sm:h-20 object-contain" />
              <div className="text-center sm:text-left">
                <h1 className="text-xl sm:text-2xl font-bold text-[#3E2723]">Admin Dashboard</h1>
                <p className="text-xs sm:text-sm text-[#3E2723]/60">Griya Bakpia Jogja</p>
              </div>
            </div>
            
            <div className="flex items-center w-full sm:w-auto justify-center sm:justify-end">
              <Button
                onClick={handleLogout}
                variant="outline"
                className="border-red-500 text-red-500 hover:bg-red-50 w-full sm:w-auto"
              >
                <LogOut size={18} className="mr-1 sm:mr-2" />
                Logout
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="bg-white p-1 shadow-sm">
            <TabsTrigger value="products" className="flex items-center gap-2">
              <Package size={18} />
              <span>Manage Products</span>
            </TabsTrigger>
            <TabsTrigger value="messages" className="flex items-center gap-2">
              <MessageSquare size={18} />
              <span>Contact Messages</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="products">
            <ProductManagement />
          </TabsContent>

          <TabsContent value="messages">
            <ContactMessages />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default AdminDashboard;
